import { render, staticRenderFns } from "./AccountBalanceItemsView.vue?vue&type=template&id=48fc1150&scoped=true&"
import script from "./AccountBalanceItemsView.vue?vue&type=script&lang=js&"
export * from "./AccountBalanceItemsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc1150",
  null
  
)

export default component.exports